import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DxTabPanelComponent } from 'devextreme-angular';

@Component({
  selector: 'app-service-and-maintenance',
  templateUrl: './service-and-maintenance.component.html',
  styleUrls: ['../messages/messages.component.css']
})
export class ServiceAndMaintenanceComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  @ViewChild("tabPanel") tabPanel: DxTabPanelComponent;
  public isMaintenance: boolean = false;
  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.subscriptions.push(this.route.params
      .subscribe(param => {
        this.tabPanel.selectedIndex = +param["viewId"] ? +param["viewId"] : 0;
        this.isMaintenance = (+param["viewId"] === 1);
      }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  public onSelectionChanged(event: any) {

    if (event.addedItems && (event.addedItems[0].title as string).toLowerCase() === "service request") {
      this.router.navigate(['/ServicesMaintenance/0/ServiceRequest']);
    } else {
      this.router.navigate(['/ServicesMaintenance/1/ServiceRequest']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/service-and-maintenance/service-and-maintenance.component.ts